// extracted by mini-css-extract-plugin
module.exports = {"itemsWrapper":"SNdWT","card":"_7hy+L"};